(function() {
  const MQ = '(max-width: 749px)';
  const SELECTOR_ROOT    = '.collapsible-text';
  const SELECTOR_CONTENT = '.collapsible-text__content';
  const SELECTOR_TOGGLE  = '.collapsible-text__toggle';

  const isMobile = () => window.matchMedia(MQ).matches;

  function updateButtonVisibility(root, content, toggle) {
    if (isMobile()) {
      // Si clampé, clientHeight < scrollHeight -> bouton visible
      const needsToggle = content.scrollHeight > content.clientHeight + 1;
      toggle.hidden = !needsToggle;
      const expanded = root.classList.contains('is-expanded');
      toggle.textContent = expanded ? 'Lire moins' : 'Lire plus';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    } else {
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  function initOne(root) {
    const content = root.querySelector(SELECTOR_CONTENT);
    const toggle  = root.querySelector(SELECTOR_TOGGLE);
    if (!content || !toggle) return;

    // État initial : clamp CSS (pas de flash)
    updateButtonVisibility(root, content, toggle);

    // Toggle simple : on pose/retire la classe .is-expanded
    toggle.addEventListener('click', () => {
      if (!isMobile()) return;
      root.classList.toggle('is-expanded');
      const expanded = root.classList.contains('is-expanded');
      toggle.textContent = expanded ? 'Lire moins' : 'Lire plus';
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

      // Après changement, on réévalue si le bouton doit rester visible
      updateButtonVisibility(root, content, toggle);

      // Optionnel: recentrer un peu après repli
      if (!expanded) {
        setTimeout(() => {
          const y = root.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 10);
      }
    });

    // Recalcul si la hauteur change (images, polices…)
    let raf;
    const apply = () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => updateButtonVisibility(root, content, toggle));
    };

    const ro = new ResizeObserver(apply);
    ro.observe(content);
    content.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', apply, { once: true });
    });

    // Recalcul si on change de viewport
    const mq = window.matchMedia(MQ);
    (mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply));
  }

  function initAll() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('pageshow', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
